var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    {
      '--overlay': _vm.overlay,
      '--horizontal': _vm.horizontal,
      '--complete': _vm.complete
    },
    'collection-item__complete-check p-absolute d-flex align-items-center justify-content-center'
  ],attrs:{"data-cy":"complete-check"}},[_c('v-icon',{attrs:{"icon":"check","size":"1rem"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }